import PublicPages from '@/layouts/PublicPages.vue'
const StaticTermsOfUsePage = () => import( '@/pages/static/StaticTermsOfUsePage.vue')
const StaticPrivacyPolicyPage = () => import( '@/pages/static/StaticPrivacyPolicyPage.vue')
const StaticDisclaimerPage = () => import( '@/pages/static/StaticDisclaimerPage.vue')
const ContactPage = () => import('@/pages/static/ContactPage.vue')
const StaticForOrganizationsPage = () => import('@/pages/static/StaticForOrganizationsPage.vue')
const StaticFreeToUsePage = () => import('@/pages/static/StaticFreeToUsePage.vue')
const StaticHowItWorksPage = () => import('@/pages/static/StaticHowItWorksPage.vue')

export default [
  { path: "/contact", name: 'ContactPage', component: ContactPage, meta: { layout: PublicPages } },
  { path: "/for-organizations", name: 'StaticForOrganizationsPage', component: StaticForOrganizationsPage, meta: { layout: PublicPages }  },
  { path: "/free-to-use", name: 'StaticFreeToUsePage', component: StaticFreeToUsePage, meta: { layout: PublicPages }  },
  { path: "/how-it-works", name: 'StaticHowItWorksPage', component: StaticHowItWorksPage, meta: { layout: PublicPages }  },
  { path: "/terms-of-use", name: 'StaticTermsOfUsePage', component: StaticTermsOfUsePage, meta: { layout: PublicPages }  },
  { path: "/privacy-policy", name: 'StaticPrivacyPolicyPage', component: StaticPrivacyPolicyPage, meta: { layout: PublicPages }  },
  { path: "/disclaimer", name: 'StaticDisclaimerPage', component: StaticDisclaimerPage, meta: { layout: PublicPages }  },
]
